import { render, staticRenderFns } from "./PopupImprovementEffect.vue?vue&type=template&id=1ccbcfd8&scoped=true"
import script from "./PopupImprovementEffect.vue?vue&type=script&lang=js"
export * from "./PopupImprovementEffect.vue?vue&type=script&lang=js"
import style0 from "./PopupImprovementEffect.vue?vue&type=style&index=0&id=1ccbcfd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbcfd8",
  null
  
)

export default component.exports